import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let DeviceTimeLine = class DeviceTimeLine extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.deviceHistory = [];
    }
    getCustomShowText(it) {
        const dictName = it.dictName || it.status || '';
        const charge = it.charge || '';
        const purpose = it.purpose || '';
        const evaluate = it.evaluate || '';
        const orderNumber = it.orderNumber || '';
        const orderType = it.orderType || '';
        const description = it.description || '';
        const remark = it.remark || '';
        const creator = it.creator || '';
        switch (true) {
            case (/计划|准备/i.test(dictName)):
                {
                    return `
        <div>
          <span v-if="creator">创建:</span><span v-if="creator" style="color: rgba(42, 130, 228, 1)">${creator}&nbsp;</span>
          <span v-if="purpose">用途:</span><span v-if="purpose" style="">${purpose}</span>
        </div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>
        <span v-if="remark">备注:</span><span v-if="remark" style="color: rgba(42, 130, 228, 1)">${remark}&nbsp;</span>`;
                }
                break;
            case (/生产/i.test(dictName)):
                {
                    return `
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>`;
                }
                break;
            case (/测试|送检|审核|验货/i.test(dictName)):
                {
                    return `
        <div>
          <span v-if="evaluate">评估:</span><span v-if="evaluate" style="color: rgba(42, 130, 228, 1)">${evaluate}&nbsp;</span>
          <span v-if="description">描述:</span><span v-if="description" style="">${description}</span>
        </div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>
        <span v-if="remark">备注:</span><span v-if="remark" style="color: rgba(42, 130, 228, 1)">${remark}&nbsp;</span>`;
                }
                break;
            case (/配送|收货|出库|入库/i.test(dictName)):
                {
                    return `
        <div>
          <span>时间:</span><span style="color: rgba(42, 130, 228, 1)">${it.time ? new Date(it.time).format('hh点mm') || '异常' : '异常'}&nbsp;</span>
          <span v-if="description">描述:</span><span v-if="description" style="">${description}</span>
        </div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>`;
                }
                break;
            case (/修|故障|升级|停用|撤离/i.test(dictName)):
                {
                    return `
        <div>
          <span v-if="description">描述:</span><span v-if="description" style="">${description}</span>
        </div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>`;
                }
                break;
            default:
                {
                    return `
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>
        <span v-if="description">备注:</span><span v-if="description" style="color: rgba(42, 130, 228, 1)">${remark}&nbsp;</span>`;
                }
                break;
        }
    }
    async getDeviceHistory(deviceInfoId) {
        if (deviceInfoId) {
            this.deviceHistory = [];
            await this.axios.get('/api/project/device/history', { params: { deviceInfoId: deviceInfoId } })
                .then((res) => {
                const result = res.data && res.data.result || [];
                this.deviceHistory = result;
            })
                .catch((err) => this.snackbar.error('获取设备信息失败!'));
        }
    }
    async mounted() {
        // console.log('item mounted 123:', JSON.stringify(this.deviceInfo))
        if (this.deviceInfo && this.deviceInfo.id) {
            await this.getDeviceHistory(this.deviceInfo.id);
        }
    }
    async created() {
    }
};
__decorate([
    Prop({ default: () => ({}) })
], DeviceTimeLine.prototype, "deviceInfo", void 0);
DeviceTimeLine = __decorate([
    Component({
        name: 'DeviceTimeLine',
        components: {
            BcSnackbar,
        },
    })
], DeviceTimeLine);
export default DeviceTimeLine;
